export const paymentReportRequestConfig = { timeout: 120000 };
export const paymentReportPdfRequestConfig = { timeout: 120000 };

export const getPaymentReportGenerationError = error => {
    if (error && error.code === "ECONNABORTED") {
        return "The report request timed out. Please try again or check the backend logs.";
    }
    if (error && error.response && error.response.data) {
        return typeof error.response.data === "string"
            ? error.response.data
            : error.response.data.error || error.response.data.message || "Could not generate the payment report.";
    }
    if (error && error.message) return error.message;
    return "Could not generate the payment report.";
};

export const getSimulationValidationError = report => {
    const jsonData = report && report.json_data ? report.json_data : {};
    if (jsonData.simulation_error) return jsonData.simulation_error;

    const boardSnapshot = jsonData.gci_board_snapshot;
    if (boardSnapshot && boardSnapshot.id) return "";

    const simulation = jsonData.gci_simulation;
    if (!simulation || !simulation.simulation_run_id) {
        return "No GCI board snapshot was created for this payment's routing sheet.";
    }

    const hasPresentationRows = Array.isArray(simulation.presentation_rows) && simulation.presentation_rows.length > 0;
    const hasPaymentRows = Array.isArray(simulation.payments) && simulation.payments.some(payment => (
        Array.isArray(payment.rows) && payment.rows.length > 0
    ));

    if (!hasPresentationRows && !hasPaymentRows) {
        return "GCI simulation was created, but it has no board rows or board snapshot. Check invoice schedule due items and associate splits for this RS.";
    }

    return "";
};
